export default "__VITE_ASSET__DzHyguiq__"